import ModalController from "./modal_controller"

// Connects to data-controller="client-modal"
export default class extends ModalController {
  static targets = ["container", "note", "tag", "dropdownContainer", "formContainer"]
  connect() {
    this.selectedType = "chooseClient"
  }

  radioChange(event) {
    const radioValue = event.target.value
    if (radioValue === "chooseClient") {
      this.showDropdown()
    } else {
      this.showForm()
    }
  }

  showForm() {
    this.selectedType = "newClient"
    const phoneField = this.formContainerTarget.querySelector("#call_client_attributes_phone")

    if (this.element.dataset.phone) {
      phoneField.value = this.element.dataset.phone
      phoneField.innerText = this.element.dataset.phone
    }
    this.dropdownContainerTarget.classList.add("hidden")
    this.formContainerTarget.classList.remove("hidden")

    const event = new CustomEvent("client-modal:show-form", {
      detail: {
        phone: this.element.dataset.phone,
        phonePrefix: this.element.dataset.phonePrefix
      }
    })
    const countryPrefixElement = this.element.querySelector("[data-controller=\"country-prefix\"]")
    countryPrefixElement.dispatchEvent(event)
  }

  showDropdown() {
    this.selectedType = "chooseClient"
    this.dropdownContainerTarget.classList.remove("hidden")
    this.formContainerTarget.classList.add("hidden")

    const event = new CustomEvent("client-modal:show-dropdown")
    // querySelector element with data-controller 'country-prefix'
    const countryPrefixElement = this.element.querySelector("[data-controller=\"country-prefix\"]")
    countryPrefixElement.dispatchEvent(event)
  }
}
